import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import convert from '../../../Helper/helper';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const labColumns = [
    {
        field: "billNumber",
        headerName: "Bill Number",
        width: 200,
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                   <p style={{ color: "blue", textDecoration: "underline", cursor:"pointer" }}>{params.row.billNumber}</p>
                </div>
            );
        },
    },
    {
        field: "billDate",
        headerName: "Bill Date",
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                   
                   <p>{convert(params.row.billDate)}</p>
                </div>
            );
        },
        width: 150,
    },

    {
        field: "patientName",
        headerName: "Patient Name",
        width: 120,
    },
    {
        field: "age",
        headerName: "Age / Sex",
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                    {
                        params?.row?.gender === "0" ? <>{params.row.age} / Male</> :
                            params?.row?.gender === "1" ? <>{params.row.age} /  Female</> : params.row.age + "/" + "Others"
                    }

                </div>
            );
        },
        width: 150,
    },
    

    {
        field: "mobile",
        headerName: "Mobile",
        width: 150,
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                    {
                        <p><SmartphoneIcon /> {params.row.mobile} <WhatsAppIcon style={{color: "green"}} /></p>
                    }

                </div>
            );
        }
    },
    {
        field: "totalAmount",
        headerName: "Total Amount",
        width: 150,
    },

    {
        field: "email",
        headerName: "Email",
        width: 230,
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                    {
                        <p><EmailIcon /> {params.row.email}</p>
                    }

                </div>
            );
        }
    },

    
];
